<template>
    <div class="force-full-height">

        <div class="header d-flex justify-space-between">
            <v-card flat class="pa-2">
                <div>INTERNATIONAL CINEMATOGRAPHERS GUILD</div>
                <div>I.A.T.S.E. LOCAL 667</div>
                <div>229 Wallace Avenue</div>
                <div>Toronto ON M6H 1V5   CANADA</div>
            </v-card>

            <div>
                &nbsp;
            </div>

            <v-card flat class="pa-2">
                <div class="text-right">Phone: 416 368-0072</div>
                <div class="text-right">Fax: 416 368-6932</div>
                <div class="text-right">Email: camera@iatse667.com</div>
            </v-card>

        </div>

        <br/>
        <br/>
        <br/>
        <br/>

        <div class="pa-2 address-window">
            <div>{{item.user_first_name}} {{item.user_last_name}} {{item.user_designation}}</div>
            <div>{{item.user_address_part1}}</div>
            <div>{{item.user_address_part2}}</div>
        </div>

        <hr/>
        <hr/>

        <v-card flat class="px-4 py-4">
            <div>RE: Base and Working Dues Receipts {{ year }}</div>
            <br/>
            <div>{{ salutation }},</div>
            <br/>
            <div>
                Enclosed, you will find your tax receipt(s) for your annual dues for the year {{ year }}.
                The amount shown on it represents the annual dues paid between January 1st and December 31st {{ year }}.
                A separate receipt for applicable working dues will be mailed early in the new year.
            </div>

            <br/>
            <div>In Solidarity,</div><br/>

                <div style="width: 200px">
                    <img src="/img/signature_of_treasurer.jpg" alt="Logo" width="79" height="32" class="mx-auto">
                    <div class="signature-title text-center">Ari Magder, Treasurer</div>
                </div>
        </v-card>

        <hr/>

        <v-card flat class="px-4 py-4">
            <div>Objet:  reçu fiscal pour {{ year }}</div>
            <br/>
            <div>{{ salutation }},</div>
            <br/>
            <div>
                Vous trouverez ci-joint votre reçu de cotisation annuelle pour fins d’impôts pour l’année {{year}}.
                Le montant indiqué représente les sommes de cotisations trimestrielles payées du 1er janvier au 31 décembre {{year}}.
                Un reçu séparé pour toute autre cotisation applicable sera envoyé au début de la nouvelle année.
            </div>

            <br/>
            <div>Syndicalement vôtre,</div><br/>

                <div style="width: 200px">
                    <img src="/img/signature_of_treasurer.jpg" alt="Logo" width="79" height="32" class="mx-auto">
                    <div class="signature-title text-center">Ari Magder, trésorière</div>
                </div>
        </v-card>

    </div>
</template>

<script>

    export default {
        name: "BaseDuesTaxReceiptLetter",
        props: {
            'year': {
                required: false,
                default: function () {
                    return 1969
                }
            },
            'item': {
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                filters: {
                    search: null,
                    date_deposit: null,
                    user_id: null,
                },
                fetch_data_response: null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'user_last_name',       text: 'Last Name',      align: `start`,     sortable: false, filterable: false,   },
                    {value: 'user_first_name',      text: 'First Name',     align: `start`,     sortable: false, filterable: false,   },
                    {value: 'sum_amount_payment',   text: 'Amount',         align: `end`,       sortable: false, filterable: false,   },
                    {value: 'date_deposit',         text: 'Deposit Date',   align: ` d-none`,   sortable: false, filterable: true,  search: this?.filters?.date_deposit },
                    {value: 'user_id',              text: 'User ID',        align: ` d-none`,   sortable: false, filterable: true,  search: this?.filters?.user_id },

                ]
            },
            salutation() {
                let concat_name = [this.item.user_first_name, this.item.user_last_name].filter(names => true).join(' ')
                return `Dear ${concat_name}`
            }

        },
        methods: {
            example() {
                console.log("This is just a test")
            },
            async exportAsPdf() {
                await this.$refs.report_list.getPdf()
            },
            getDisplayName() {
                if (!this.item) {
                    return ''
                }
                return !!this.item?.user_last_name ? `${this.item?.user_last_name}, ${this.item?.user_first_name}` : this.item?.user_first_name
            },
            getDisplayAmount() {
                if (!this.item) {
                    return ''
                }
                let numeric_value = parseFloat(this.item?.sum_amount_payment)
                if (Number.isNaN(numeric_value)) {
                    return ''
                }
                let num_fixed = (Math.round(numeric_value * 100) / 100).toFixed(2)
                let num_formatted = new Intl.NumberFormat('en-CA', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(num_fixed)
                return num_formatted.replaceAll(',', ' ')
            },
        },
    }
</script>

<style>
html,body, .v-application, .v-app, .font-change {
    font-size: 10pt;
    font-family: ABCFavorit, system-ui, sans-serif !important;
}

.pagebreak {
    page-break-after: always;
    min-height: 1px;
}

.force-full-height {
    height: 100vh !important;
    width: 100vw !important;
}

.tearline {
    border-bottom: #cccccc 1px dashed;
}

@page  {
    size: letter portrait;
}

@media print {
    .address-windows {
        position: fixed;
        top: 5.8cm; /* start of envelope window */
        left: 2cm;  /* adjust as needed */
    }
}


</style>
